module.exports = __webpack_public_path__ + "img/banner-TazzTME.7c55b0da.jpg";